module.exports = __webpack_public_path__ + "img/carlos-ferreira.93cc0e0e.jpg";